/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { GetPreferencesQueryResponse } from '../types/GetPreferences'

function getGetPreferencesUrl() {
  const res = { method: 'GET', url: `/api/v1/preferences/` as const }
  return res
}

/**
 * @summary Get tooltips, feature flags, company-type prefixes, misc settings, reporting unit
 * {@link /api/v1/preferences/}
 */
export async function getPreferences(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetPreferencesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetPreferencesUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
